import { icons } from 'src/assets/iconDef/icon.def';

export const DataOnBoardingMenuDef = [
  {
    name: 'menu.bulk_upload_permissions',
    icon: 'fa fa-tag',
    resource: 'bulk_upload_permissions',
    url: 'bulk_upload_permissions',
    auto_crud: true
  },
  {
    name: 'menu.drug_class_master_upload',
    icon: 'fa fa-tag',
    resource: 'drug_class_master_upload',
    url: 'drug_class_master_upload',
    auto_crud: true
  },
  {
    name: 'menu.oneClick_practitioner',
    icon: 'fa fa-tag',
    resource: 'oneClick_practitioner',
    url: 'oneClick_practitioner',
    auto_crud: true
  },
  {
    name: 'menu.growth_chart_master_upload',
    icon: 'fa fa-tag',
    resource: 'growth_chart_master_upload',
    url: 'growth_chart_master_upload',
    auto_crud: true
  },
  {
    name: 'menu.master_definition',
    icon: 'fa fa-tag',
    resource: 'master_definition',
    url: 'master_definition',
    auto_crud: true
  },
 
  {
    name: 'menu.master_upload_checklist',
    icon: 'fa fa-tag',
    resource: 'master_upload_checklist',
    url: 'master_upload_checklist',
    auto_crud: true
  },
  {
    name: 'menu.master_upload_account',
    icon: 'fa fa-tag',
    resource: 'master_upload_account',
    url: 'master_upload_account',
    auto_crud: true
  },
  {
    name: 'menu.gct_master',
    icon: 'fa fa-tag',
    resource: 'gct_master',
    url: 'gct_master',
    auto_crud: true
  },
  {
    name: 'menu.master_upload_process_history',
    icon: 'fa fa-tag',
    resource: 'master_upload_process_history',
    url: 'master_upload_process_history',
    auto_crud: true
  },
  {
    name: "clinical_document_master",
    resource: 'clinical_document_master',
    icon: icons.list.horizontalList,
    url: 'clinical_document_master',
    showMenu: true,
    auto_crud: true
  },
  {
    name: "field.label.clinical_document_master_block_view",
    resource: 'clinical_document_master_view_block',
    icon: icons.list.horizontalList,
    url: 'clinical_document_master_view_block',
    check_permission: false,
    auto_crud: true
  },
  {
    name: 'menu.master_upload_failed_records',
    icon: 'fa fa-tag',
    resource: 'master_upload_failed_records',
    url: 'master_upload_failed_records',
    auto_crud: true
  },
  {
    name: 'menu.workflow_master',
    icon: 'fa fa-tag',
    resource: 'workflow_master',
    url: 'workflow_master',
    auto_crud: true
  },
  {
    name: 'menu.print_master',
    icon: 'fa fa-tag',
    resource: 'print_master',
    url: 'print_master',
    auto_crud: true
  },
  {
    name: 'menu.mis_master',
    icon: 'fa fa-tag',
    resource: 'mis_master',
    url: 'mis_master',
    auto_crud: true
  },
  {
    name: 'menu.master_template_list',
    icon: 'fa fa-tag',
    resource: 'master_template_list',
    url: 'master_template_list',
    auto_crud: true
  },
  {
    name: 'menu.mis_master',
    icon: 'fa fa-tag',
    resource: 'onboarding_format',
    url: 'onboarding_format',
    auto_crud: false
  },
  {
    name: 'menu.onboarding_format_for_sales',
    icon: 'fa fa-tag',
    resource: 'onboarding_format_for_sales',
    url: 'onboarding_format_for_sales',
    auto_crud: false
  },
  {
    name: 'menu.emr_master',
    icon: 'fa fa-tag',
    resource: 'emr_master',
    url: 'emr_master',
    auto_crud: true
  },
  {
    name: 'menu.sms_template_master',
    icon: 'fa fa-tag',
    resource: 'sms_template_master',
    url: 'sms_template_master',
    auto_crud: true
  },
  {
    name: 'menu.feature_request',
    icon: 'fa fa-tag',
    resource: 'feature_request',
    url: 'feature_request',
    auto_crud: true
  }, 
  {
    name: 'menu.Project_plan',
    icon: 'fa fa-tag',
    resource: 'Project_plan',
    url: 'Project_plan',
    auto_crud: true
  }, 
  // {
  //   name: 'menu.machine_integration',
  //   icon: 'fa fa-tag',
  //   resource: 'machine_integration',
  //   url: 'machine_integration',
  //   auto_crud: true
  // },
  // {
  //   name: 'menu.system_integration',
  //   icon: 'fa fa-tag',
  //   resource: 'system_integration',
  //   url: 'system_integration',
  //   auto_crud: true
  // },
  {
    name: 'menu.kx_resource_mapping',
    icon: 'fa fa-tag',
    resource: 'kx_resource_mapping',
    url: 'kx_resource_mapping',
    auto_crud: true
  },
  {
    name: 'menu.customer_resource_mapping',
    icon: 'fa fa-tag',
    resource: 'customer_resource_mapping',
    url: 'customer_resource_mapping',
    auto_crud: true
  },
  {
    name: 'menu.sms_master_template',
    icon: 'fa fa-tag',
    resource: 'sms_master_template',
    url: 'sms_master_template',
    auto_crud: true
  },
  {
    name: 'menu.email_master_template',
    icon: 'fa fa-tag',
    resource: 'email_master_template',
    url: 'email_master_template',
    auto_crud: true
  },
  {
    name: 'menu.notification_master_template',
    icon: 'fa fa-tag',
    resource: 'notification_master_template',
    url: 'notification_master_template',
    auto_crud: true
  },
  // {
  //   name: 'menu.workflow_state_management',
  //   icon: 'fa fa-tag',
  //   resource: 'workflow_state_management',
  //   url: 'workflow_state_management',
  //   auto_crud: true
  // },
  // {
  //   name: 'menu.print_state_management',
  //   icon: 'fa fa-tag',
  //   resource: 'print_state_management',
  //   url: 'print_state_management',
  //   auto_crud: true
  // },
  // {
  //   name: 'menu.mis_state_management',
  //   icon: 'fa fa-tag',
  //   resource: 'mis_state_management',
  //   url: 'mis_state_management',
  //   auto_crud: true
  // },
  {
    name: 'menu.branding_master',
    icon: 'fa fa-tag',
    resource: 'branding_master',
    url: 'branding_master',
    auto_crud: true
  },
  {
    name: 'menu.branding_state_management',
    icon: 'fa fa-tag',
    resource: 'branding_state_management',
    url: 'branding_state_management',
    auto_crud: true
  },
  {
    name: 'menu.branding_master',
    icon: 'fa fa-tag',
    resource: 'role_per_facility',
    url: 'role_per_facility',
    auto_crud: true
  },
  {
    name: 'menu.branding_master',
    icon: 'fa fa-tag',
    resource: 'master_credentials',
    url: 'master_credentials',
    auto_crud: true
  },
  {
    name: 'menu.onboarding_event_template',
    icon: 'fa fa-tag',
    resource: 'onboarding_event_template',
    url: 'onboarding_event_template',
    auto_crud: true
  },
  // {
  //   name: 'menu.emr_state_management',
  //   icon: 'fa fa-tag',
  //   resource: 'emr_state_management',
  //   url: 'emr_state_management',
  //   auto_crud: true
  // },
  {
    name: 'menu.desk_state_management',
    icon: 'fa fa-tag',
    resource: 'desk_state_management',
    url: 'desk_state_management',
    auto_crud: true
  },
  // {
  //   name: 'menu.training_scheduler',
  //   icon: 'fa fa-tag',
  //   resource: 'training_scheduler',
  //   url: 'training_scheduler',
  //   auto_crud: true
  // },
  {
    name: 'menu.onboarding_price_calculator_array',
    icon: 'fa fa-tag',
    resource: 'onboarding_price_calculator_array',
    url: 'onboarding_price_calculator_array',
    auto_crud: true
  },
  {
    name: 'menu.onboard_with_quotation',
    icon: 'fa fa-tag',
    resource: 'onboard_with_quotation',
    url: 'onboard_with_quotation',
    auto_crud: true
  },
  {
    name: 'menu.hazelcast_upload_data',
    icon: 'fa fa-tag',
    resource: 'hazelcast_upload_data',
    url: 'hazelcast_upload_data',
    auto_crud: true
  },
  {
    name: 'menu.un_encrypt',
    icon: 'fa fa-tag',
    resource: 'un_encrypt',
    url: 'un_encrypt',
    auto_crud: true
  },
  {
    name: 'menu.un_encrypt_details',
    icon: 'fa fa-tag',
    resource: 'un_encrypt_details',
    url: 'un_encrypt_details',
    auto_crud: true
  },
  {
    name: 'menu.failed_messages',
    icon: 'fa fa-tag',
    resource: 'failed_messages',
    url: 'failed_messages',
    auto_crud: true
  },
  {
    name: 'menu.oltp_to_mis_v1',
    icon: 'fa fa-tag',
    resource: 'oltp_to_mis_v1',
    url: 'oltp_to_mis_v1',
    auto_crud: true
  },
  {
    name: 'menu.db_migration_master',
    icon: 'fa fa-tag',
    resource: 'db_migration_master',
    url: 'db_migration_master',
    auto_crud: true
  },
  {
    name: "clinical_document_label_master",
    resource: 'clinical_document_label_master',
    icon: icons.list.horizontalList,
    url: 'clinical_document_label_master',
    showMenu: true,
    auto_crud: true
  },
  {
    name: 'menu.smb_master_definition',
    icon: 'fa fa-tag',
    resource: 'smb_master_definition',
    url: 'smb_master_definition',
    auto_crud: true
  },
  {
    name: 'menu.onboarding_status',
    resource: "onboarding_status",
    icon: 'fa fa-h-square',
    url: 'onboarding_status',
    application: 'data-onboarding',
    check_permission: false,
    auto_crud: true,
    showMenu: true
  }
]
